import { render, staticRenderFns } from "./IncripcionExamenNivel1.vue?vue&type=template&id=6f0f66c5&"
import script from "./IncripcionExamenNivel1.vue?vue&type=script&lang=js&"
export * from "./IncripcionExamenNivel1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports